import { Button, ButtonVariant, Intent, Tag, Tooltip } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"
import { ILandingConsoleStore, ILandingStore, useLandingConsoleStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { getLandingContainer } from "../../../utils/getLandingContainer"
import { LANDING_EDIT_MODE } from "src/modules/pe-landing-module/data/interfaces"
import { setCursor } from "."

/* Protopia Ecosystem component */
export interface IDragToolProps {
   
}
const DragTool = (props: IDragToolProps): JSX.Element => {
    const editMode                              = useLandingConsoleStore((state: ILandingConsoleStore) => state.editMode) 
    const setDrag: (isDrag: boolean) => void    = useLandingStore((state: ILandingStore) => state.setDrag)  
    const setIsDrag = () => {
        useLandingConsoleStore.setState({ editMode: LANDING_EDIT_MODE.DRAG }) 
        setCursor("move")
        setDrag(true)
    }
    return <Tooltip 
            content={ <div className="small letter-spacing-1 flex-centered"> 
                <div className="button-label">{ __( "Drag" ) }</div>
                <Tag minimal className="ml-2 px-2 py-0"><div className="smallest text-light title">CTRL + D</div></Tag>
            </div> } 
            intent={Intent.PRIMARY}
            className=" ml-auto" 
            position="right"
            compact
            hoverOpenDelay={600}
            portalClassName="z-index-90"
            modifiers={{ 
                arrow: { enabled: true },
                flip: { enabled: true },
                preventOverflow: { enabled: false },
                offset: { 
                    enabled: true, 
                    options: {
                        offset: [0, 2],
                    } 
                }, 
            }}
        >
            <Button variant={ editMode === LANDING_EDIT_MODE.DRAG ? ButtonVariant.SOLID : ButtonVariant.MINIMAL} onClick={ setIsDrag } >
                <div className={`d-flex flex-column align-items-center ${editMode === LANDING_EDIT_MODE.DRAG ? "" : "opacity_5"}`}>
                    <img src="/assets/img/landing/drag.svg" alt="" height={15} className="panel-icon" /> 
                </div>
            </Button>
        </Tooltip>
}
export default DragTool